import { createContext, useContext } from 'react';

/**
 * True when a widget is being rendered inside the dual panel (a widget panel or the
 * dashboard canvas) rather than inline in the chat.
 */
const InPanelContext = createContext(false);

export const InPanelProvider = InPanelContext.Provider;

export const useIsInPanel = (): boolean => useContext(InPanelContext);
